module.exports = __webpack_public_path__ + "static/sama_fat-b33e9141b12227fbd510d15d71f976e4.jpeg";